import React, { ReactElement } from 'react';
import { TextBlock } from './TextBlock/TextContent';

import styles from './Description.module.scss';
import { IEventContent } from "@common/redux/types/event";
import classNames from "classnames";

interface IProps {
  content: IEventContent[],
}

export const Description = ({
  content,
}: IProps): ReactElement => {

  const renderContent = (item, index: number) => {
    if (item.type === 'text') {
      return (
        <TextBlock key={`${item.type}${index}`} text={item.text}/>
      );
    }
    return <></>
  }

  return (
    <div className={styles.content}>
      <div className={classNames(styles.wrapper)}>
        {typeof content === 'string' ?
          <TextBlock text={content}/> :
          content?.map(renderContent)
        }
      </div>
    </div>
  )
};
